import {
  GET_DAMAGE_RECEIPT_DETAIL_REQUEST,
  GET_DAMAGE_RECEIPT_DETAIL_SUCCESS,
  GET_DAMAGE_RECEIPT_DETAIL_ERROR
} from "../actions/types";

export const damageDetail = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_DAMAGE_RECEIPT_DETAIL_REQUEST:
      return {
        loading: true,
      };
    case GET_DAMAGE_RECEIPT_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        payload: payload,
      };
    case GET_DAMAGE_RECEIPT_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
